<template>
    <div class="c2b-container">
        <div class="c2b-router-name-container">
            <p class="c2b-router-name">Relatório de comissão</p>
        </div>

        <div class="c2b-content">
            <div class="modal" tabindex="-1" role="dialog" id="c2b-seller-commission-list-filter-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Filtro</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-6 form-group">
                                    <label>Data inicial</label>
                                    <v-date-picker 
                                        :input-props="{'class': 'form-control'}" 
                                        popover-visibility="focus"
                                        v-model="sellerComissionListFilter.date.start" />
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Data final</label>
                                    <v-date-picker 
                                        :input-props="{'class': 'form-control'}" 
                                        popover-visibility="focus"
                                        v-model="sellerComissionListFilter.date.end" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Vendedor</label>
                                    <input type="text"
                                        class="form-control"
                                        v-model="sellerComissionListFilter.partnerSellerName" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="getSellerListWithFilter(sellerComissionListFilter)"
                                :disabled="loadingFilter">
                                    Filtrar
                                    <Loading v-show="loadingFilter" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="clearFilter()">Restaurar</button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeFilterModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="c2b-seller-commission-specific-modal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="float-left">
                                <h5 class="modal-title">Comissão</h5>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-9 form-group">
                                    <label>Descrição</label>
                                    <p class="mb-0">{{chosenSellerCommission.description}}</p>
                                </div>

                                <div class="col-12 col-md-3 form-group">
                                    <label>Tipo</label>
                                    <p>{{chosenSellerCommission.type.name | infoOrPlaceholder}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-6 form-group">
                                    <label>Vendedor</label>
                                    <p>{{chosenSellerCommission.partnerEmployee.realName}}</p>
                                    <small class="text-muted">{{chosenSellerCommission.partnerEmployee.name}}</small>
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Cliente</label>
                                    <p class="mb-0">{{chosenSellerCommission.subscriber.realName}}</p>
                                    <small class="text-muted">{{chosenSellerCommission.subscriber.name}}</small>
                                    <br>
                                    <small class="text-muted">{{chosenSellerCommission.subscriber.idExternal}}</small>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-3 form-group">
                                    <label>Faturamento</label>
                                    <p>{{chosenSellerCommission.total | currency}}</p>
                                </div>

                                <div class="col-12 col-md-3 form-group">
                                    <label>Perc. base</label>
                                    <p>{{chosenSellerCommission.partnerPercentageComission}} %</p>
                                </div>

                                <div class="col-12 col-md-3 form-group">
                                    <label>Perc. vendedor</label>
                                    <p>{{chosenSellerCommission.employeePercentage}} %</p>
                                </div>

                                <div class="col-12 col-md-3 form-group">
                                    <label>Comissão</label>
                                    <p>{{chosenSellerCommission.totalComission | currency}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeComissionDetailsModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <Loading v-if="loading" />

            <div v-show="!loading">
                <div class="mb-3">
                    <button class="btn btn-primary" @click="openFilterModal()">
                        Filtro
                    </button>

                    <json-to-csv
                        class="btn btn-outline-secondary ml-3"
                        :data="sellerComissionListCsv"
                        name="comissao.csv">
                        Exportar para CSV
                    </json-to-csv>
                </div>

                <FilterInformationCmp 
                    v-if="!loading"
                    :filter-submitted="sellerComissionListFilterSubmitted"
                    :filter-properties="sellerComissionFilterProperties" />

                <NothingFound v-if="nothingToShow" />

                <div class="table-responsive" v-show="!nothingToShow">
                    <table class="table table-hover table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Cliente</th>
                                <th>Tipo</th>                                
                                <th class="text-right">Faturamento</th>
                                <th class="text-right">Comissão</th>                                
                                <th class="text-right">Pago em</th>                     
                                <th></th>           
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(sellerComission, index) of sellerComissionList" :key="index">
                                <td>
                                    <p class="mb-0">{{sellerComission.partnerEmployee.realName}}</p>
                                    <small class="text-muted">{{sellerComission.partnerEmployee.name}}</small>
                                </td>
                                <td>
                                    <p class="mb-0">{{sellerComission.subscriber.realName}}</p>
                                    <small class="text-muted">{{sellerComission.subscriber.name}}</small>
                                    <br>
                                    <small class="text-muted">{{sellerComission.subscriber.idExternal}}</small>
                                </td>
                                <td>{{sellerComission.type.name}}</td>
                                <td class="text-right">{{sellerComission.total | currency}}</td>
                                <td class="text-right">{{sellerComission.totalComission | currency}}</td>
                                <td class="text-right">{{sellerComission.paymentDate | dateFilter}}</td>
                                <td class="text-center c2b-td-with-buttons">
                                    <button type="button" 
                                        class="btn btn-default text-muted" 
                                        data-toggle="dropdown" >
                                        <fa icon="ellipsis-v"/>
                                    </button>

                                    <div class="dropdown-menu">  
                                        <span class="dropdown-item" 
                                            @click="openComissionDetailsModal(sellerComission)">Detalhes</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import ModalService from '../../utils/services/ModalService'
import reportService from '../../report/services/ReportService';
import { SellerComissionListFilterFormModel } from '../models/SellerComissionListFilterFormModel'
import FilterInformationCmp from '@/utils/components/FilterInformationCmp'
import { dateFilter } from '@/utils/filters/DateTimeFilter'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import { SellerComissionModel } from '../models/SellerComissionModel';

const ID_SELLER_COMMISSION_LIST_FILTER_MODAL = '#c2b-seller-commission-list-filter-modal'
const ID_SELLER_COMMISSION_SPECIFIC_MODAL = '#c2b-seller-commission-specific-modal'

export default {
    name: 'SellerComissionListReportView',
    filters: {
        dateFilter,
        infoOrPlaceholder,
    },
    components: {
        FilterInformationCmp,
    },
    data() {
        return {
            loading: true,
            loadingFilter: false,
            chosenSellerCommission: new SellerComissionModel(),
            sellerComissionListFilter: new SellerComissionListFilterFormModel(),
            sellerComissionListFilterSubmitted: new SellerComissionListFilterFormModel(),
            sellerComissionList: [],
            sellerComissionListCsv: [],
            breadcrumbList: [
                {
                    id: 1,
                    path: '/vendedores',                    
                    description: 'Vendedores',
                },
                {
                    id: 1,
                    description: 'Relatório de comissão',
                },
            ],
            sellerComissionFilterProperties: [
                {
                    type: 'daterange',
                    label: 'Data',
                    property: 'date',
                },
            ],
        }
    },
    async mounted() {
        this.loading = true

        this.sellerComissionListFilterSubmitted = cloneDeep(this.sellerComissionListFilter)

        try {
            this.sellerComissionList = await reportService.getSellerEmployeeComissionList(this.sellerComissionListFilterSubmitted)
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
    methods: {
        async getSellerListWithFilter(filterForm) {
            this.loadingFilter = true

            this.sellerComissionListFilterSubmitted = cloneDeep(filterForm)

            try {
                this.sellerComissionList = await reportService.getSellerEmployeeComissionList(this.sellerComissionListFilterSubmitted)
                this.closeFilterModal()
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.loadingFilter = false
        },
        clearFilter() {
            this.sellerComissionListFilter = new SellerComissionListFilterFormModel()
        },
        openFilterModal() {
            ModalService.show(ID_SELLER_COMMISSION_LIST_FILTER_MODAL)
        },
        closeFilterModal() {
            ModalService.hide(ID_SELLER_COMMISSION_LIST_FILTER_MODAL)
        },
        openComissionDetailsModal(sellerComission) {
            this.chosenSellerCommission = sellerComission
            ModalService.show(ID_SELLER_COMMISSION_SPECIFIC_MODAL)
        },
        closeComissionDetailsModal() {
            ModalService.hide(ID_SELLER_COMMISSION_SPECIFIC_MODAL)
        },
    },
    computed: {
        nothingToShow() {
            return !this.loading && !this.sellerComissionList.length
        },
    },
    watch: {
        sellerComissionList(val) {
            this.sellerComissionListCsv = val.map((s) => {
                return {
                    vendedor: s.partnerEmployee.realName,
                    vendedor_alias: s.partnerEmployee.name,
                    vendedor_codigo_crm: s.partnerEmployee.idExternal,
                    cliente_razao_social: s.subscriber.realName,
                    cliente_nome_fantasia: s.subscriber.name,
                    cliente_codigo_crm: s.subscriber.idExternal,
                    base: s.sellerSubscriber.realName,
                    tipo_faturamento: s.type.name,
                    origem: 'Alterdata',
                    total_faturamento: s.total,
                    percentual: s.percentage,
                    valor_comissao: s.totalComission,
                    pago_em: dateFilter(s.paymentDate),
                }
            })
        },
    },
}
</script>